@if (isLoadingPortingDates()) {
  <div class="spinner-container">
    <app-spinner />
  </div>
} @else {
  <form class="number-chooser-form" [formGroup]="form">
    <app-two-g-sunset-information />

    <p class="choose-mobile-phone-number-heading number-chooser-heading">Velg telefonnummer</p>

    <div class="select-container">
      <app-ice-select-box
        label="Eksisterende nummer"
        radioTestId="existing-number-select-box-input"
        [control]="form.controls.isPortingOrder"
        [value]="true"
      >
        <div bodyContent class="porting-number-content">
          <app-ice-input-field
            forId="aNumberWithPorting"
            formControlName="aNumberWithPorting"
            inputWidth="medium"
            label="Telefonnummer"
            ngDefaultControl
            ngxsFormPath="formState.subscriptionForm"
            textTestId="a-number-with-porting-input"
            [errorOnTouchedOnly]="true"
            [errorText]="getMsisdnErrorText(form.controls.aNumberWithPorting.errors)"
            [maxLength]="8"
          />
          @if (form.controls.aNumberWithPorting.status === FormStatus.PENDING) {
            <app-spinner />
          } @else {
            @if (trialSubscriptionErrorMessage) {
              <app-ice-alert type="error" [iconName]="IconNames.ice_warning">
                <div heading>Brukeren kvalifiserer ikke for "Prøv Oss"</div>
                <div class="anumber-with-porting-error-text">
                  {{ trialSubscriptionErrorMessage }}
                </div>
              </app-ice-alert>
            }
            @if (form.controls.isOwnerChange.value) {
              <app-ice-alert type="info" [iconName]="IconNames.ice_info">
                <div heading>Ice-eierskifte</div>
                <div class="anumber-with-porting-error-text">
                  Nummeret har en annen juridisk eier i Ice. Eierskifte-SMS vil bli sendt når orderen er bekreftet og
                  kontrakt signert.
                </div>
              </app-ice-alert>
            }
            @if (form.controls.aNumberWithPorting.hasError('blockedSubscription')) {
              @if (hasSecretNumberAccess()) {
                <app-ice-card type="critical">
                  <app-ice-alert type="critical" [iconName]="IconNames.ice_warning">
                    <div heading>OBS!</div>
                    <div class="anumber-with-porting-error-text">
                      Eieren av dette nummeret må selv ta kontakt med kundeservice.
                    </div>
                  </app-ice-alert>
                  <app-info-accordion
                    class="porting-error-accordion"
                    testId="secret-number-error-info-accordion-button"
                    type="critical"
                    [displayIcon]="false"
                  >
                    <div class="porting-error-accordion-header" header>
                      Vis årsak&nbsp;
                      <span>Ikke oppgi årsak til kunde</span>
                    </div>
                    <div content>Hemmelig nummer</div>
                  </app-info-accordion>
                </app-ice-card>
              } @else {
                <app-ice-alert type="error" [iconName]="IconNames.ice_warning">
                  <div heading>Nummeret kan ikke brukes</div>
                  <div class="anumber-with-porting-error-text">Eier av nummeret må kontakte kundeservice.</div>
                </app-ice-alert>
              }
            }
            @if (form.controls.aNumberWithPorting.hasError('customerAlreadyOwnsMsisdn')) {
              <app-ice-alert type="error" [iconName]="IconNames.ice_warning">
                <div class="anumber-with-porting-error-text">Kunden har allerede et abonnement på dette nummeret.</div>
              </app-ice-alert>
            }
            @if (form.controls.aNumberWithPorting.hasError('connectedSubscriptionInChangeState')) {
              <app-ice-alert type="error" [iconName]="IconNames.ice_warning">
                <div heading>Nummeret prosesseres</div>
                <div class="anumber-with-porting-error-text">
                  Nummeret kan ikke porteres, det er allerede et ICE abonnement knyttet til dette nummeret som prosesseres.
                </div>
              </app-ice-alert>
            }
            @if (form.controls.aNumberWithPorting.hasError('isSubscriptionIsAccessNumber')) {
              <app-ice-alert type="error" [iconName]="IconNames.ice_warning">
                <div heading>Aksessnumre kan ikke brukes</div>
                <div class="anumber-with-porting-error-text">Kontakt kundeservice for mer informasjon.</div>
              </app-ice-alert>
            }
          }
        </div>
      </app-ice-select-box>
      <app-ice-select-box
        label="Få nytt nummer"
        radioTestId="new-number-select-box-input"
        [control]="form.controls.isPortingOrder"
        [hideOverflow]="false"
        [value]="false"
      >
        @if (aNumberOptions?.length > 1) {
          <div bodyContent>
            <app-ice-select
              buttonTestId="a-number-with-new-number-button"
              formControlName="aNumberWithNewNumber"
              inputWidth="small"
              label="Reserverte numre"
              ngDefaultControl
              ngxsFormPath="formState.subscriptionForm"
              placeholder="'Velg reservert nummer'"
              textTestId="a-number-with-new-number-input"
              [options]="aNumberOptions"
            />
          </div>
        } @else if (aNumberOptions?.length === 1) {
          <div bodyContent>
            <p class="single-new-number-title">Reservert nummer</p>
            <p>{{ aNumberOptions[0] }}</p>
          </div>
        }
      </app-ice-select-box>
    </div>

    @if (form.controls.aNumberWithPorting.hasError('apiException')) {
      <app-ice-alert type="error" [iconName]="IconNames.ice_warning">
        Noe gikk galt under validering av telefonnummer, prøv igjen senere.
      </app-ice-alert>
    }
    <div class="sim-registration">
      <p class="sim-type-heading number-chooser-heading">Velg SIM-type</p>
      @if (simTypeCompatibilityText) {
        <p>{{ simTypeCompatibilityText }}</p>
      } @else {
        <app-esim-info-modal />
      }

      <div class="select-container">
        <app-ice-select-box
          label="eSIM"
          radioTestId="esim-input"
          [control]="form.controls.simCardOptions"
          [value]="SimCardOptions.ESim"
        >
          @if (displayEIDForm) {
            <div bodyContent>
              <app-ice-input-field
                forId="eId"
                formControlName="eid"
                inputWidth="large"
                label="Skann EID-koden"
                ngDefaultControl
                ngxsFormPath="formState.subscriptionForm"
                textTestId="eid-input"
                [errorOnTouchedOnly]="false"
                [longHelpText]="eidLongHelpText"
                [maxlength]="32"
                [minlength]="32"
              />

              <div
                class="eid-info-tooltip"
                matTooltip="Du finner EID-koden på esken ved IMEI og EAN-nummerne"
                matTooltipPosition="above"
                role="tooltip"
              >
                <mat-icon [svgIcon]="IconNames.ice_info" />
                Slik finner du EID
              </div>
            </div>
          }
        </app-ice-select-box>
        <app-ice-select-box
          label="Fysisk SIM-kort"
          radioTestId="physical-sim-input"
          [control]="isPhysicalSimControl"
          [value]="true"
        />
        @if (form.controls.isOwnerChange.value) {
          <app-ice-select-box
            label="Behold eksisterende SIM"
            radioTestId="keep-existing-sim-input"
            [control]="form.controls.simCardOptions"
            [value]="SimCardOptions.KeepExisting"
          />
        }
      </div>

      @if (isOnlySupportingEsim && isPhysicalSimControl.value) {
        <app-ice-alert type="warning" [iconName]="IconNames.ice_info">
          <b class="sim-warning-title">Obs! Denne telefonen kan bare bruke eSIM!</b>
          <br />
          Du kan bestille et fysisk sim-kort dersom kunden ønsker å bruke telefonen med et annet abonnement
        </app-ice-alert>
      } @else if (isOnlySupportingPsim && !isPhysicalSimControl.value) {
        <app-ice-alert type="warning" [iconName]="IconNames.ice_info">
          <b class="sim-warning-title">Obs! Denne telefonen kan bare bruke fysisk SIM-kort!</b>
          <br />
          Du kan bestille et eSIM dersom kunden ønsker å bruke telefonen med et annet abonnement
        </app-ice-alert>
      }
      @if (!!isPhysicalSimControl.value) {
        <p class="physical-sim-heading number-chooser-heading">Fysisk SIM-kort</p>
        <div class="select-container">
          <app-ice-select-box
            label="Registrer nytt SIM-kort"
            radioTestId="register-new-sim-input"
            [control]="form.controls.simCardOptions"
            [value]="SimCardOptions.RegisterNew"
          >
            @if (form.controls.simCardOptions.value === SimCardOptions.RegisterNew) {
              <div bodyContent>
                <app-ice-input-field
                  forId="icc"
                  formControlName="icc"
                  inputWidth="medium"
                  label="SIM-nummer"
                  ngDefaultControl
                  ngxsFormPath="formState.subscriptionForm"
                  placeholder="Scan eller skriv inn"
                  textTestId="icc-input"
                  [errorOnTouchedOnly]="true"
                  [errorText]="getSimCardErrorTexts(form.controls.icc.errors, SimCardType.Voice)"
                  [maxlength]="20"
                  [minlength]="19"
                />
              </div>
            }
          </app-ice-select-box>
          <app-ice-select-box
            label="Send nytt SIM-kort i posten"
            radioTestId="send-new-sim-in-post-input"
            [control]="form.controls.simCardOptions"
            [value]="SimCardOptions.SendToMail"
          />
        </div>
      }

      @if (isDelayedESim) {
        <app-ice-alert type="info">
          Tidligste overføringstidspunkt er senere enn vanlig fordi ordren inneholder et fysisk SIM-kort som skal sendes i
          posten.
        </app-ice-alert>
      }

      <p class="porting-heading number-chooser-heading">Velg overføringstidspunkt</p>
      <app-activation-date
        [initialIsEarliestPortingDate]="isEarliestPortingDate"
        [isPhysicalSim]="isPhysicalSimControl.value"
        [isPorting]="isPortingOrderControl.value"
        [orderSim]="orderSimControl.value"
        (isEarliestPortingDate)="onEarliestPortingDateChange($event)"
      />

      @if (form.controls.isOwnerChange.value) {
        <app-ice-alert type="info">
          Tidligere eier må godkjenne eierskiftet før nummeret kan overføres. Dette kan føre til at aktiveringstidspunktet
          utsettes
        </app-ice-alert>
      }
    </div>
  </form>
}

<dialog #eSimDelayWarning class="esim-delay-warning">
  <h2>Utsatt porteringstid for eSIM</h2>
  <p>
    Hvis du legger til et fysisk SIM-kort som skal sendes i posten vil porteringstiden for abonnement med eSIM i denne ordren
    bli utsatt til
    <b>{{ earliestDateTime | date }}.</b>
  </p>
  <p>Ønsker du å fortsette?</p>
  <div class="action-buttons">
    <app-ice-button color="outlined" testId="abort-sim-delay-button" (click)="preventESimChange()">Avbryt</app-ice-button>
    <app-ice-button color="secondary" testId="confirm-sim-delay-button" (click)="confirmESimChange()">
      Fortsett
    </app-ice-button>
  </div>
</dialog>
